if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector(".form");

        this.stickyBarWrapper = this.querySelector(".sticky-add-to-cart");

        console.log("this.stickyBarWrapper: " + this.stickyBarWrapper);
        if (this.stickyBarWrapper) {
          this.stickyAtcHandler();
        }
        this.form.querySelector("[name=id]").disabled = false;
        console.log("What is this?" + this);
        this.smoothScrollToTop = document.querySelector(".variant-notice-msg");
        this.chillerOptionSelector = document.querySelectorAll(
          ".variantChiller__option"
        );
        this.chillerOptionSelector.forEach((chillerOptionElement) => {
          chillerOptionElement.addEventListener(
            "click",
            this.chillerOptionHandler.bind(this)
          );
        });

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        const upsellATCBtn = document.querySelectorAll(".upsellATCCheckbox");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.smoothScrollToTop.addEventListener("click", function () {
          this.noticeWrapper = document.querySelector(
            ".variant-notice-wrapper"
          );
          if (this.noticeWrapper.classList.contains("notice-open")) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
      }
      smoothScrollToTop() {
        if (document.documentElement.scrollTop > 0) {
          // Scroll to the top using smooth behavior
          window.scrollBy(0, -40);
          requestAnimationFrame(scrollToTop);
        }
      }
      chillerOptionHandler(evt) {
        console.log("chillerOptionHandler trigged");
        this.chillerOption = document.querySelectorAll(
          ".variantChiller__option"
        );
        this.optionSelected = evt.target;
        this.chillerOption.forEach((chillerOption) => {
          chillerOption.classList.remove("chiller__optionSelected");
        });
        evt.target.classList.add("chiller__optionSelected");
        const wrapperElement = document.querySelector(
          ".variantChiller__optionsInput-wrapper"
        );
        const optionElements = document.querySelectorAll(
          ".variant__chiller-option"
        );

        if (this.optionSelected.getAttribute("data-option-value") === "Yes") {
          wrapperElement.style.transition = "height 0.2s ease";
          wrapperElement.style.height = "102px";

          optionElements.forEach((optionElement, index) => {
            optionElement.style.transition = "opacity 0.4s ease";
            optionElement.style.opacity = "1";
          });
        } else {
          const chillerOptionDeselectRadio = document.querySelector(
            ".variantChiller__optionsInput-wrapper input[value=No]"
          );
          chillerOptionDeselectRadio.checked = true;

          // Trigger the change event on the radio button to notify any listeners
          chillerOptionDeselectRadio.dispatchEvent(new Event("change"));
          optionElements.forEach((optionElement, index) => {
            optionElement.style.transition = "opacity 0.2s ease";
            optionElement.style.opacity = "0";
          });

          setTimeout(() => {
            wrapperElement.style.transition = "height 0.4s ease";
            wrapperElement.style.height = "0";
          }, (optionElements.length - 1) * 100);
        }

        /*
      if (this.optionSelected.getAttribute('data-option-value') === 'Yes') {
        
        this.optionSelected.closest(".variant__chiller-wrapper").classList.add("chiller__optionsOpen");
      } else {
        this.optionSelected.closest(".variant__chiller-wrapper").classList.remove("chiller__optionsOpen");
      }*/
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        console.log("Running Test");
        this.handleErrorMessage();
        this.toggleLoadingState(true);

        const subscriptionUpsell = document.querySelector(
          "subscription-upsell"
        );

        let subUpsellValidation = null;
        let subFormData;
        let subConfig;
        if (subscriptionUpsell) {
          subFormData = this.prepareSubFormData();
          subConfig = this.prepareFetchSubConfig(subFormData);
          subUpsellValidation = true;
        }
        console.log("subscriptionUpsell: " + subscriptionUpsell);
        console.log("subUpsellValidation: " + subUpsellValidation);

        const formData = this.prepareFormData();

        const config = this.prepareFetchConfig(formData);

        this.formID = this.form.getAttribute("id");
        const quickAddForm = this.formID.includes("quick-add");

        if (
          !quickAddForm &&
          subUpsellValidation &&
          subscriptionUpsell.querySelector("#add-subscription").checked
        ) {
          // First fetch request
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              // Update the body of the config for the second request
              //config.body = subFormData;
              // Second fetch request

              return fetch(`${routes.cart_add_url}`, subConfig);
            })
            .then((response) => response.json())
            .then((response) => {
              this.handleFetchResponse(response); // Handle the final response
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              if (subscriptionUpsell) {
                //subscriptionUpsell.handleSubscriptionUpsellAddition();
              }
              this.toggleLoadingState(false);
            });
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) =>
              this.handleFetchResponse(response, quickAddForm)
            )
            .catch((error) => console.error(error))
            .finally(() => {
              //this.handleSubscriptionUpsellAddition();
              this.toggleLoadingState(false);
            });
        }
      }
      prepareFormData() {
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        return formData;
      }
      prepareSubFormData() {
        const subFormData = new FormData(
          document.querySelector("subscription-upsell .shopify-product-form")
        );
        const subSectionURL = document
          .querySelector(".subscription-upsell-wrapper")
          .getAttribute("data-section-url");
        if (this.cart) {
          subFormData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          subFormData.append("sections_url", subSectionURL);
          this.cart.setActiveElement(document.activeElement);
        }

        return subFormData;
      }
      prepareFetchConfig(formData) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;
        return config;
      }
      prepareFetchSubConfig(subFormData) {
        const subConfig = fetchConfig("javascript");
        subConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        delete subConfig.headers["Content-Type"];
        subConfig.body = subFormData;
        return subConfig;
      }
      handleFetchResponse(response, quickAdd) {
        console.log("Upsell product response", response);
        if (response.status) {
          this.handleErrorMessage(response.description);
          this.updateSoldOutState();
          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response, quickAdd);
        }
      }

      updateSoldOutState() {
        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
      }

      toggleLoadingState(isLoading) {
        if (isLoading) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        } else {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      upsellAddToCartHandler(evt) {
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        const clickedElement = evt.target;
        const getProductId = (element) =>
          clickedElement
            .closest(".product-upsell-box")
            .getAttribute("data-product-id");
        const getSectionUrl = (element) =>
          clickedElement
            .closest(".product-upsell-box")
            .getAttribute("data-section-url");
        const getUpsellProductId = getProductId(clickedElement);
        const getUpsellSectionUrl = getSectionUrl(clickedElement);

        const sectionIdData = document
          .querySelector(".product")
          .getAttribute("data-section-id");
        const getUpsellQuantity = document.getElementById(
          "Quantity-" + sectionIdData
        ).value;
        if (event.target.checked) {
          console.log("Closest Product Id: " + getUpsellProductId);
          console.log("Closest Product Section Url: " + getUpsellSectionUrl);
          var data = {
            id: getUpsellProductId,
            quantity: 1,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: getUpsellSectionUrl,
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                //window.location = window.routes.cart_url;
                //return;
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
            });
        } else {
          var data = {
            updates: {},
            sections: ["cart-drawer", "cart-icon-bubble"],
            section_url: getUpsellSectionUrl,
          };
          data.updates[getUpsellProductId] = 0;

          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                //window.location = window.routes.cart_url;
                //return;
              }

              this.error = false;
              this.cart.renderContents(response);
            })
            .catch((error) => {
              // Handle errors that occur during the request
              console.error("Error removing product from cart:", error);
            });
        }
      }
      upsellAlternativeAddOnTest(
        getUpsellProductId,
        getUpsellQuantity,
        getUpsellSectionUrl
      ) {
        var data = {
          id: getUpsellProductId,
          quantity: getUpsellQuantity,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: getUpsellSectionUrl,
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              //window.location = window.routes.cart_url;
              //return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }
      stickyAtcHandler() {
        const stickyAddBtn = this.querySelector(".sticky-atc--action .button");
        const mainAddBtn = this.querySelector(".product-form__submit");

        const elementToApplyClass = document.querySelector(
          ".sticky-add-to-cart"
        );
        const changeSelectionBtns = this.querySelectorAll(
          ".sticky-atc--jumpToVariants"
        );

        // Listen for scroll events
        window.addEventListener("scroll", this.stickyApplyClass.bind(this));
        //this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // Check initially if the element is in viewport
        this.stickyApplyClass();

        stickyAddBtn.addEventListener("click", function (event) {
          event.preventDefault();
          mainAddBtn.click();
        });
        if (changeSelectionBtns) {
          changeSelectionBtns.forEach((changeSelectionBtn) => {
            changeSelectionBtn.addEventListener(
              "click",
              this.stickyJumpToVariant.bind(this)
            );
          });
        }
      }
      addButtonVisibility(element, footerElement) {
        console.log("element" + element);
        const rect = element.getBoundingClientRect();
        const footerRect = footerElement.getBoundingClientRect();
        // Calculate the bottom position of the element relative to the whole document
        const elementTopPosition = rect.bottom + window.scrollY;
        const footerElementTopPosition = footerRect.bottom + window.scrollY;

        // Get the viewport height
        const viewportHeight = window.innerHeight;

        // Get the scroll position
        const scrollPosition = window.scrollY;

        const isButtonVisible =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth);
        const isFooterVisible =
          footerRect.bottom >= 0 &&
          footerRect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          footerRect.right >= 0 &&
          footerRect.left <=
            (window.innerWidth || document.documentElement.clientWidth);
        // Check if the top of the element is below the viewport
        let isViewportBelowButton = false;
        if (scrollPosition > elementTopPosition) {
          isViewportBelowButton = true;
        } else if (scrollPosition < elementTopPosition) {
          isViewportBelowButton = false;
        }
        console.log("isFooterVisible: " + isFooterVisible);

        if (
          (isViewportBelowButton && !isButtonVisible) ^
          (isViewportBelowButton && !isButtonVisible && isFooterVisible)
        ) {
          return false;
        } else {
          return true;
        }
      }
      stickyJumpToVariant() {
        event.preventDefault();

        // Select the .variant-radios element
        const variantRadios = document.querySelector("variant-radios");

        // Check if the .variant-radios element exists
        if (variantRadios) {
          const yOffset = -100; // The offset value
          const elementPosition =
            variantRadios.getBoundingClientRect().top + window.pageYOffset;

          // Scroll to the element with the offset
          window.scrollTo({
            top: elementPosition + yOffset,
            behavior: "smooth",
          });
        }
      }
      stickyApplyClass() {
        const elementToCheck = document.querySelector(".sticky-attach");
        const footerElement = document.querySelector(".footer");
        const elementToApplyClass = document.querySelector(
          ".sticky-add-to-cart"
        );

        const hidePopups = document.querySelectorAll(
          "#gorgias-chat-container, button.needsclick"
        );
        if (
          this.addButtonVisibility(elementToCheck, footerElement) ||
          document.querySelector("body").classList.contains("upcartPopupShow")
        ) {
          elementToApplyClass.classList.add("sticky-close");
          hidePopups.forEach((element) => {
            element.classList.remove("sticky-add-bar-open");
          });
          $(".prouduct-options-wrapper").append("variant-radios");
        } else {
          elementToApplyClass.classList.remove("sticky-close");
          hidePopups.forEach((element) => {
            element.classList.add("sticky-add-bar-open");
          });
        }
      }
    }
  );
}
if (!customElements.get("subscription-upsell")) {
  customElements.define(
    "subscription-upsell",
    class SubscriptionUpsell extends HTMLElement {
      constructor() {
        super();
        this.sellingPlanSelection();
        this.addSubscriptionCheckbox = this.querySelector("#add-subscription");
        this.sellingPlanSelect = this.querySelector(".selling-plan-selection");

        this.addSubscriptionCheckbox.addEventListener(
          "change",
          this.enableSubscriptionUpsell.bind(this.addSubscriptionCheckbox)
        );
        this.sellingPlanSelect.addEventListener(
          "change",
          this.sellingPlanEventHandler.bind(this.sellingPlanSelect)
        );
      }
      enableSubscriptionUpsell() {
        this.parent = this.closest(".subscription-upsell-inner").querySelector(
          ".subscription-purchase-options"
        );
        if (this.checked) {
          this.parent.classList.add("expand-purchase-options");
        } else {
          this.parent.classList.remove("expand-purchase-options");
        }
      }
      handleSubscriptionUpsellAddition() {
        // ... (Your upsell handling code here | copy paste one from product-form.js)
        let formData = {
          items: [
            {
              id: 44559558246566,
              quantity: 1,
              selling_plan: 1441595558,
              sections: ["cart-drawer", "cart-icon-bubble"],
              sections_url: "/products/water-maintenance-pack",
            },
          ],
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              //window.location = window.routes.cart_url;
              //return;
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }
      sellingPlanSelection() {
        var sellingPlanContainer = document.querySelector(
          ".selling-plan-fieldset"
        );
        var product = JSON.parse(
          sellingPlanContainer.querySelector("script").innerText
        );
        var productForm = document.querySelector(
          ".subscription-purchase-options .shopify-product-form"
        );
        var findSelectedVariant = function () {
          var selectedVariantId = parseInt(
            document.querySelector(
              '.subscription-purchase-options .shopify-product-form [name="id"]'
            ).value
          );
          var selectedVariant;

          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id === selectedVariantId) {
              selectedVariant = product.variants[i];
              break;
            }
          }

          return selectedVariant;
        };

        // Watch for selling plan option change to update the selected selling plan

        /*
        sellingPlanContainer
          .querySelectorAll("select")
          .forEach(function (optionSelector) {
            optionSelector.addEventListener("change", function () {
              var selectedVariant = findSelectedVariant();
              var availableSellingPlanAllocations =
                selectedVariant.selling_plan_allocations;
              var selectedSellingPlanId;

              for (var i = 0; i < availableSellingPlanAllocations.length; i++) {
                var sellingPlan =
                  availableSellingPlanAllocations[i].selling_plan;
                var matchingSellingPlan = false;

                // Logic to find matching selling plan

                if (matchingSellingPlan) {
                  selectedSellingPlanId = sellingPlan.id;
                }
              }

              selectedSellingPlanId =
                typeof selectedSellingPlanId === "undefined"
                  ? ""
                  : selectedSellingPlanId;
              document.querySelector('[name="selling_plan"]').value =
                selectedSellingPlanId;
            });
          }); */
      }
      sellingPlanEventHandler() {
        // Remove the 'selected' attribute from all options
        this.querySelectorAll("option").forEach((option) => {
          option.removeAttribute("selected");
        });

        // Get the currently selected option
        const selectedOption = this.options[this.selectedIndex];

        // Set the 'selected' attribute on the currently selected option
        selectedOption.setAttribute("selected", "");
        const selectedOptionPrice = selectedOption.getAttribute("data-price");
        const selectedOptionComparePrice =
          selectedOption.getAttribute("data-compare-price");
        const comparePriceItem = document.querySelector(
          "subscription-upsell .upsell-price--price-sale"
        );
        const priceItem = document.querySelector(
          "subscription-upsell .upsell-price--price"
        );

        priceItem.innerHTML = selectedOptionPrice;
        // Get the 'data-selling-plan-id' attribute value of the selected option
        const sellingPlanId = selectedOption.getAttribute(
          "data-selling-plan-id"
        );

        // Output the 'data-selling-plan-id'
        const selectParent = this.closest("form");
        const sellingPlanHiddenInput = selectParent.querySelector(
          "input[name=selling_plan]"
        );
        sellingPlanHiddenInput.value = sellingPlanId;
      }
    }
  );
}

if (!customElements.get("delivery-eta")) {
  customElements.define(
    "delivery-eta",
    class DeliveryEta extends HTMLElement {
      constructor() {
        super();

        // Current date
        let currentDate = new Date();

        // Calculate date-from and date-to
        let dateFrom = this.addDays(currentDate, 2);
        let dateTo = this.addDays(currentDate, 4);

        // Format the dates
        let dateFromString = this.formatDate(dateFrom);
        let dateToString = this.formatDate(dateTo);
        console.log(
          `Order now to get it by ${dateFromString} - ${dateToString}`
        );
        this.etaTextElement = this.querySelector(".delivery-eta-time");

        this.etaTextElement.innerHTML = `${dateFromString} - ${dateToString}.`;
      }
      addDays(date, days) {
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      // Function to format the date in "dd MMM" format
      formatDate(date) {
        const options = { day: "2-digit", month: "short" };
        return date.toLocaleDateString("en-US", options);
      }
    }
  );
}
